import { getLiabilityStatusFromId, getPolicyLimtsText } from "../../../lib/labels";
import CheckboxCell from "../../common/interactive/CheckboxCell";

export default function LiabilityPart({dataItem, classes}) {
    return <>
        {dataItem && dataItem.liability_status != 0 && <>
            <h4 className={classes.flex_betwen}>Liability 
                <div className={classes.status}>{getLiabilityStatusFromId(dataItem.liability_status)}</div>
            </h4>
            <div className={classes.background_container}>
                <div className={classes.row}>Carrier: {dataItem.insurance_carrier?.name}</div>
                {dataItem.claim_number && <div className={classes.row}>Claim #: {dataItem.claim_number}</div>}
                {dataItem.policy_limit_patient && <div className={classes.row}>Liability Limit Patient: <b>{getPolicyLimtsText(dataItem.policy_limit_patient)}</b></div>}
                {dataItem.policy_limit_accident && <div className={classes.row}>Liability Limit Accident: <b>{getPolicyLimtsText(dataItem.policy_limit_accident)}</b></div>}
                {dataItem.liability_paid_at && <div className={classes.row}>Liability paid at: <b>{dataItem.liability_paid_at}</b></div>}   
                {dataItem.vehicle_model && <div className={classes.row}>
                    Vehicle:: <b>{dataItem.vehicle_model} {dataItem.vehicle_year}</b>
                    
                    {dataItem.vehicle_damage && <>, damage: <b>{dataItem.vehicle_damage}</b></>}
                </div>} 
                <hr />
                <div className={classes.row}>
                    <div className={`${classes.flex_container_align_center} ${classes.flex_wrap}`}>
                        {dataItem.at_fault == 1 && <CheckboxCell label={'Other Vehicle'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>}
                        {dataItem.at_fault == 2 && <CheckboxCell label={'Patient at fault'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>}
                        {dataItem.commercial_policy ? <CheckboxCell label={'Commercial'} checked={dataItem.commercial_policy} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}
                        {dataItem.gov_entity ? <CheckboxCell label={'Gov. Entity'} checked={dataItem.gov_entity} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}
                        {dataItem.hit_run ? <CheckboxCell label={'Hit & Run'} checked={dataItem.hit_run} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}
                        {dataItem.dui ? <CheckboxCell label={'DUI'} checked={dataItem.dui} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}
                        {dataItem.ride_share ? <CheckboxCell label={'Rideshare'} checked={dataItem.ride_share} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}                 
                        
                    </div>
                </div>
                

                {dataItem.verified ? <>
                    <hr />
                    <div>Verified by <b>{dataItem.verified_by}</b> at <b>{dataItem.verified_date}</b></div>
                </> : ''}
                
            </div>
        </>}
        
    </>
}